import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
  Spin
} from "antd";
import { PageHeader } from '@ant-design/pro-components';

import { SearchOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { isValidCPF } from 'cnpj-cpf-validator';

import { apiCand } from "../../../services/apiCand";

import { useNavigate } from "react-router-dom";
import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { AlignType } from 'rc-table/lib/interface';

import "../style.css";
import { maskCpf } from "../../../utils/maskFunctions";
import { IAxiosErrorResponseData } from "../../../Interfaces/Interfaces";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { IPessoaFisicaConsulta } from "../Componentes/InterfacePessoaFisica";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../parametrosUI";
import { modalApi } from "../../../config/AntdGlobalProvider";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";


interface IProps {
  tipoMandato: string;
  caminhoCadastro: string;
}

const Consultar: React.FC<IProps> = (props: IProps) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [estadoErroApiGet, setEstadoErroApiGet] = useState(0)
  const [msgErroApi, setMsgErroApiGet] = useState("")

  const [pessoasFisicas, setPessoasFisicas] = useState<IPessoaFisicaConsulta[]>([]);

  const nuCpf = form.getFieldValue("nuCpf");

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoPag, setEstadoPag] = useState({
    fluxoPagina: 0,
    query: "",
    valores: {
      linhaPorPagina: DEFAULT_PAGE_SIZE,
      nuCpf: "",
      pagina: 1,
      nmPessoaFisica: "",
    },
  });



  const [dadosPF, setDadosPF] = useState({
    idPessoaFisica: 0,
    nmPessoaFisica: "",
    nuCpf: "",
  });


  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  function pushToCadastro(idPessoaFisica: number, nmPessoaFisica: string, nuCpf: string) {
    setDadosPF({
      idPessoaFisica: idPessoaFisica,
      nmPessoaFisica: nmPessoaFisica,
      nuCpf: nuCpf,
    });
  }

  function pushToCadastroPessoaFisica(nuCpf: string) {
    setDadosPF({
      idPessoaFisica: -1,
      nmPessoaFisica: "",
      nuCpf: nuCpf,
    });
  }

  useEffect(() => {
    if (dadosPF.idPessoaFisica !== 0) navigate(props.caminhoCadastro, { state: dadosPF });
    if (dadosPF.idPessoaFisica === -1) navigate("/pessoa-fisica/cadastrar", { state: dadosPF });
  }, [dadosPF]);

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      width: 180,
      title: "CPF",
      dataIndex: "",
      render: (pf: IPessoaFisicaConsulta) => (
        <Input
          value={maskCpf(pf.nuCpf)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      width: 400,
      title: "Nome Completo",
      dataIndex: "nmPessoaFisica",
    });

    cols.push({
      width: 100,
      title: "Selecionar",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (pf: IPessoaFisicaConsulta) => (
        <Button
          shape="round"
          id='detalhar'
          icon={<SearchOutlined />}
          htmlType="button"
          onClick={() =>
            pushToCadastro(pf.idPessoaFisica, pf.nmPessoaFisica, pf.nuCpf)
          }
        />
      ),
    });

    return cols;
  }

  useEffect(() => {
    if (msgErroApi) {
      if (estadoErroApiGet === 400) {
        mostrarInfo("Erro de Requisição", msgErroApi);
      } else if (estadoErroApiGet === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApiGet === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setEstadoErroApiGet(0);
      setMsgErroApiGet("");

    }
  }, [msgErroApi]);

  const columns = gerarColunas();

  const cpfNaoEncontrado = () => {
    mostrarConfirmarNovaPf();
  };

  const getPessoaFisica = async () => {
    form
      .validateFields([
        "nuCpf",
      ])
      .then(() => {
        sendForm();
      })
      .catch((error) => {
        errorMessage("Existe algum erro de preenchimento de campo");
      });
  };

  const sendForm = async () => {
    try {
      setTipLoading("Buscando informações sobre Pessoas Físicas ...");
      setLoading(true);

      const nuCpf = onlyNumbers(form.getFieldValue("nuCpf")) || "";
      const nmPessoaFisica = form.getFieldValue("nmPessoaFisica") || "";
      const linhaPorPagina = form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE;

      let res:{ content: any[]; totalElements: number } = {content: [], totalElements: 0};
      let lQuery = '';
      if (nmPessoaFisica){
        lQuery = `pessoasFisicas?limit=${linhaPorPagina}&nuCpf=${nuCpf}&page=0&nmPessoaFisica=${nmPessoaFisica}`;
        const { data } = await apiCand.get(lQuery);
        res = data;
      } else if (nuCpf) {
        lQuery = `pessoasFisicas/cpf/${nuCpf}`;
        try {
          const { data } = await apiCand.get(lQuery);
          res.totalElements = 1;
          res.content.push(data);
        } catch (error: any) {}
      }

      setPessoasFisicas(res.content);
      setTotalElements(res.totalElements);
      gerarJsonState(lQuery);

      if (res.content.length === 0) {
        cpfNaoEncontrado();
      }
    } catch (error: any) {
      let data: IAxiosErrorResponseData = error.response.data;
      let msgErro = data.error;
      let msgDetalheErro = data.message;
      if (data.status < 500) {
        setEstadoErroApiGet(data.status);
        setMsgErroApiGet(msgErro + " " + msgDetalheErro);
      } else {
        errorMessage(msgErro);
      }

    } finally {
      setLoading(false);
    }

  }


  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page,
    });
    getPessoaFisica();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getPessoaFisica();
  };

  // useEffect(() => {
  //   setLoading(true);
  //   if (isStateValid(state)) {
  //     setEstadoPag(state);

  //     form.setFieldsValue({
  //       nuCpf: state.valores.nuCpf,
  //       nmPessoaFisica: state.valores.nmPessoaFisica,
  //       linhaPorPagina: state.valores.linhaPorPagina,
  //       pagina: state.valores.pagina,
  //     });

  //     getPessoaFisica(state.query);
  //   } else {
  //     form.setFieldsValue({
  //       nuCpf: "",
  //       nmPessoaFisica: "",
  //       linhaPorPagina: DEFAULT_PAGE_SIZE,
  //       pagina: 1,
  //     });
  //   }
  //   setLoading(false);
  // }, []);

  function gerarJsonState(lQuery: any) {
    setEstadoPag({
      fluxoPagina: 0,
      query: lQuery,
      valores: {
        linhaPorPagina: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE,
        nuCpf: onlyNumbers(form.getFieldValue("nuCpf")) || "",
        pagina: form.getFieldValue("pagina") || 0,
        nmPessoaFisica: form.getFieldValue("nmPessoaFisica") || "",
      },
    });
  }

  function limparConsulta() {
    setPessoasFisicas([]);
    setTotalElements(0);
    form.resetFields();
  }

  const maskFieldCpf = (isValue: string) => {
    if (form.getFieldValue("nuCpf")) {
      isValue = form.getFieldValue("nuCpf");
    }

    form?.setFieldsValue({
      nuCpf: maskCpf(isValue),
    });
  };

  useEffect(() => {
    maskFieldCpf(nuCpf);
  }, [nuCpf]);

  function mostrarConfirmarNovaPf() {
    modalApi.confirm({
      title: "Pessoa Física não cadastrada",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: "Deseja realizar o cadastro?",
      okButtonProps: { id: 'ok' },
      onOk() {
        pushToCadastroPessoaFisica(form.getFieldValue("nuCpf"));
      },
      onCancel() { },
    });
  }

  return (
    <Spin spinning={loading} >

      <>
        <PageHeader
          className="site-page-header"
          title={`Cadastro de ${props.tipoMandato} - Consultar Pessoa Física`}
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>
          <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
            <Form.Item name="pagina" />
            <Form.Item name="linhaPorPagina" />
            <Row>
              <Col xs={24} sm={5}>
                <Form.Item label="CPF" name="nuCpf"
                  rules={[
                    {
                      message: 'Insira um CPF válido.',
                      validator: (_, value) => {
                        if (value !== null && value.length !== 0) {
                          if (value.length === 14) {
                            if (isValidCPF(value)) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('CPF inválido');
                            }
                          }
                        } else {
                          return Promise.resolve();
                        }
                      }
                    }
                  ]}
                >
                  <Input
                    value={form.getFieldValue("nuCpf")}
                    onChange={(e) => maskFieldCpf(e.target.value)}
                    placeholder="Digitar o número do CPF"
                    maxLength={14}
                  />
                </Form.Item>
              </Col>

              {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) && (
              <Col xs={24} sm={12}>
                <Form.Item label="Nome" name="nmPessoaFisica">
                  <Input placeholder="Digitar o nome" />
                </Form.Item>
              </Col>
              )}
            </Row>

            <Row justify="center">
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  id="consultar"
                  type="primary"
                  value="default"
                  shape="round"
                  onClick={() => getPessoaFisica()}
                >
                  Consultar
                </Button>
                <Button
                  id="limpar"
                  value="default"
                  shape="round"
                  onClick={() => limparConsulta()}
                >
                  Limpar
                </Button>
              </>
            </Row>
          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
          <Table
            // className="overflowConsulta"
            dataSource={pessoasFisicas}
            columns={columns}
            rowKey="id"
            loading={loading}
            pagination={{
              // disabled: loading,
              // current: form.getFieldValue("pagina"),
              defaultPageSize: DEFAULT_PAGE_SIZE,
              pageSize: pageSize,
              total: totalElements,
              showSizeChanger: true,
              onShowSizeChange: handleShowSizeChange,
              onChange: handlePaginationChange,
              pageSizeOptions: PAGE_SIZE_OPTIONS,
              locale: { items_per_page: "Linhas por página" },
            }}
          />
        </Card>
      </>
    </Spin>
  );
};

export default Consultar;
